import React from 'react';
import PropTypes from 'prop-types';
import { Border, Button, ButtonContainer, CalendarHeader, CalendarWrapper, ConfirmVisitText, StyledModal } from './style';
import { AdminCloseIcon } from '../../../utils/icons';
import { Modal } from 'react-bootstrap';
import { CommonButtonPopup } from '../../HealthCoach/styles';

const CommonModalNew = ({
  show,
  icon,
  buttonIcon,
  title,
  description,
  onCancel,
  onConfirm,
  cancelText,
  subDescription,
  confirmButtonText,
  modalWidth = "400px",
  modalHeight,
  confirmButtonWidth,
  cancelButtonWidth,
  onClose,
  note,
  descriptionColor,
  isFontSize,
  isPopupMargin,
  confirmDisabled
}) => (
  <StyledModal show={show} width={modalWidth} height={modalHeight}>
    <div className="modal-content-padding">
      <CalendarHeader>
        <div className="left-content">
          <div className="icon">{icon && icon}</div>
          <div>{title}</div>
        </div>
        <div className="close-icon" onClick={()=>onClose ? onClose() :onCancel()}>
          {AdminCloseIcon()}
        </div>
      </CalendarHeader>
      <Border  isBorder={"0.75px solid #EFEFEF"}/>
      <CalendarWrapper>
        <ConfirmVisitText>{description}</ConfirmVisitText>
        {subDescription ? <ConfirmVisitText  margin={isPopupMargin} isColor= {descriptionColor || "#CE7841"}> {subDescription}</ConfirmVisitText> :null}
        {note ? (<div className="second-text">
          {note}
        </div>):null}
      </CalendarWrapper>
    </div>

    <Modal.Footer style={{borderTop:'none',display:'flex',paddingTop:'0px',justifyContent:'center'}}>

      <ButtonContainer>
        {cancelText ? <Button
          isWidth={cancelButtonWidth || "131px"}
          isHeight="40px"
          background="transparent"
          color="#184A61"
          isFont={isFontSize}
          backgroundHover="none"
          onClick={onCancel}
        >
          {cancelText}
        </Button>:null}
        {confirmButtonText ? <CommonButtonPopup
          width={confirmButtonWidth || '100%'}
          height="40px"
          isFont={isFontSize}
          background="#DA6C74"
          //   color="#DA6C74"
          onClick={onConfirm}
          disabled={confirmDisabled}
          padding={'0px'}
        >{buttonIcon && buttonIcon}
          {confirmButtonText}
        </CommonButtonPopup>:null}
      </ButtonContainer>

    </Modal.Footer>
  </StyledModal>
);


CommonModalNew.propTypes = {
  show: PropTypes.bool.isRequired,
  title:PropTypes.string, 
  confirmText: PropTypes.string, 
  cancelButtonWidth: PropTypes.string,
  description: PropTypes.string.isRequired,
  subDescription: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  cancelText: PropTypes.string,
  confirmButtonText: PropTypes.string,
  modalWidth: PropTypes.string,
  modalHeight: PropTypes.string,
  icon: PropTypes.node.isRequired, 
  buttonIcon:PropTypes.node.isRequired, 
  confirmButtonWidth:PropTypes.string, 
  onClose:PropTypes.func,
  note:PropTypes.string,
  descriptionColor: PropTypes.string,
  isFontSize: PropTypes.string,
  isPopupMargin: PropTypes.string,
  confirmDisabled:PropTypes.bool
};
  


export default CommonModalNew;
